import { render, staticRenderFns } from "./KrHistoryPopover.vue?vue&type=template&id=1993bdda&scoped=true&"
import script from "./KrHistoryPopover.vue?vue&type=script&lang=js&"
export * from "./KrHistoryPopover.vue?vue&type=script&lang=js&"
import style0 from "./KrHistoryPopover.vue?vue&type=style&index=0&id=1993bdda&scoped=true&lang=css&"
import style1 from "./KrHistoryPopover.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1993bdda",
  null
  
)

export default component.exports